import axios from 'axios'

const post = async (endpoint, body) => {
  return await (
    await axios.post(endpoint, body)
  )?.data
}

export { post }
